import * as React from 'react';

import styles from './marketing-outreach-email.module.css';

type Props = {
    bodyHtml: string;
};

/* Component responsible for rendering a marketing email
 * inside of a modal. Since the email is HTML, we'll just
 * display it as such. This is "safe" is the sense that
 * our emails that we send from Nutshell are sanitized
 * and all javascript and top-level tags are removed */
export function MarketingOutreachEmail(props: Props) {
    return (
        <div
            dangerouslySetInnerHTML={{__html: props.bodyHtml}}
            className={styles['marketing-outreach-email']}
        />
    );
}
